import { useAxios } from 'src/hooks/use-axios';

type Options = {
  storageBidId: number;
};

export function useWithdrawStorageBid() {
  return useAxios(
    (axios, baseConfig, { storageBidId }: Options) =>
      axios.request<null>({
        ...baseConfig,
        url: `${PRISMA_CONFIG.monolithApiUrl}/storage-offer/bids/${storageBidId}`,
        method: 'DELETE',
      }),
    { neededOnPageLoad: false }
  );
}

export type WithdrawStorageBidRequest = ReturnType<
  typeof useWithdrawStorageBid
>;
